module.exports = "/_next/static/images/RoostifyVideoCoverImage-ce813cbd6a5209d14dfb0391906082f8.png";